<template>
  <li class="nav-item" :class="['layer'+layer,show?'show':'']" @tap.stop="navClick(data)">
    <div class="nav-item-text">{{data.name}}<img class="m-l-5" v-show="data.children"
                                                 src="../../assets/img/header/arrow.png"
                                                 :class="{'rotate180':isUnfold}"></div>
    <ul v-if="data.children" class="nav-item-ul">
      <nav-item-mobile ref="navItem" v-for="(item, mobileIndex) in data.children" :data="item" :index="mobileIndex"
                       :key="mobileIndex" :layer="layer+1" :show="isUnfold"></nav-item-mobile>
    </ul>
  </li>
</template>

<script>
  export default {
    name: "NavItemMobile",
    props: {
      index: Number,
      data: Object,
      layer: Number,
      show: Boolean
    },
    data() {
      return {};
    },
    computed: {
      isUnfold() {
        return this.$store.state.navState[this.layer] === this.index;  //展开
      },
    },
    methods: {
      navClick(route) {
        const currentIndex = this.$store.state.navState[this.layer];   //当前层级
        if (currentIndex == this.index) {
          this.$store.commit('updateNavState', {index: this.layer, value: -1});   //使其折叠
        } else {
          this.$store.commit('updateNavState', {index: this.layer, value: this.index});  //使其展开
        }
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            this.$store.commit('foldNav');
            if (route.path.indexOf("http") != -1) {
              window.open(route.path, "_blank");
            }
            else {
              this.$router.push({path: route.path});
            }
          }
        }
      },
    }
  }

</script>

<style scoped>
  .show > .nav-item-text {
    max-height: 40px;
    transition: max-height .3s ease;
  }

  .nav-item-text {
    max-height: 0;
    height: auto;
    transition: max-height .3s ease;
  }

  .pc-box .nav-item-container .layer1 {
    line-height: 30px;
    font-size: 15px;
  }

  .pc-box .nav-item-container .layer1:hover > .nav-item-text {
    color: #333;
  }

  .pc-box .nav-item-container .layer2 {
    line-height: 30px;
    font-size: 14px;
  }

  .pc-box .nav-item-container .layer2:hover {
    color: #eb580e;
  }

  .nav-item {
    width: 100%;
  }

  .nav-item ul {
    overflow: hidden;
  }

  .nav-item ul li {
    max-height: 0;
    transition: max-height .3s ease;
  }

  .nav-item:hover ul li {
    max-height: 40px;
    transition: max-height .3s ease;
  }

  .mobile-box .nav-item-container .layer1 {
    line-height: 40px;
    font-size: 15px;
    text-indent: 15px;
    opacity: .8;
  }

  .mobile-box .nav-item-container .layer1:hover > .nav-item-text {
    color: #fff;
  }

  .mobile-box .nav-item-container .layer2 .nav-item-text {
    font-size: 14px;
    text-indent: 30px;
  }

  .mobile-box .nav-item .nav-item-text {
    position: relative;
  }

  .mobile-box .nav-item .nav-item-text > img {
    position: absolute;
    right: 0px;
    top: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMenuMobile/NavItemMobile.vue